import BudgetModes from '@/common/enums/budget-modes.enum';
import { Package } from '@/common/models';

import { EntityAvailsDataHelper } from './EntityAvailsDataHelper';

export class PackageAvailsDataHelper extends EntityAvailsDataHelper {
  constructor(protected deal: Package) {
    super(deal);
  }

  protected fetchDeliveredImpressions(): Promise<number> {
    return Promise.resolve(0);
  }

  protected async getCPM(): Promise<number> {
    if (!this.deal.isCPMFromRateCard) {
      return this.deal.cpmFixed;
    }
    const cpm = await this.getCPMForTargets();
    return cpm.average_cpm;
  }

  protected async fetchDeliveryGoal(): Promise<number> {
    try {
      if (this.deal.budgetMode === BudgetModes.IMPRESSIONS) {
        return this.deal.marketTargetedImpressionsMin;
      }
      return await this.computeDeliveryGoalFromCpm(this.deal.budgetMax);
    } catch (error) {
      console.error(error);
      return 0;
    }
  }
}
